import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { waLink, PHONE_NUMBER } from "../lib/api";

export default function FloatingButtons() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a href={`tel:${PHONE_NUMBER}`} className="w-14 h-14 rounded-full bg-[#0A2540] text-white shadow-2xl hover:scale-110 transition flex items-center justify-center" aria-label="Call now" data-testid="floating-call-btn">
        <Phone className="w-6 h-6" />
      </a>
      <a href={waLink()} target="_blank" rel="noopener noreferrer" className="w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition flex items-center justify-center relative" aria-label="WhatsApp us" data-testid="floating-wa-btn">
        <MessageCircle className="w-6 h-6" />
        <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-red-500 animate-pulse" />
      </a>
    </div>
  );
}
